/*! js-cookie v3.0.0 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      value = converter.write(value, key);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie = key + '=' + value + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        if (value[0] === '"') {
          value = value.slice(1, -1);
        }

        try {
          var foundKey = defaultConverter.read(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));

(function($) {
    /**
     * Menu script
     */
    
    class Clinic_FAQ {
        constructor () {
            this.summaries = document.querySelectorAll('summary:not(.pricing-item-title)');
            
            if (this.summaries && this.summaries.length) {
                this.summaries.forEach((summary) => {
                    summary.addEventListener('click', () => {
                        this.closeOpenedDetails();
                    }, false);
                });
            }
        }
    
        closeOpenedDetails () {
            this.summaries.forEach((summary) => {
                let detail = summary.parentNode;
                
                if (detail !== this.parentNode) {
                    detail.removeAttribute('open');
                }
            });
        }
    }
    /**
     * Menu script
     */
    class Clinic_Menu {
        constructor() {
            this.menuIsSticky = false;
            this.initState();
            this.initEvents();
            this.initStickyDetection();
        }
    
        initState() {
            this.win = $(window);
            this.menuWrapper = $('.site-header');
            this.menuIcon = this.menuWrapper.find('.menu-toggle');        
        }
    
        initEvents() {
            this.menuIcon.attr('aria-expanded', 'false');
    
            this.menuIcon.on('click', e => {
                let menuIconState = this.menuIcon.attr('aria-expanded');
    
                if (menuIconState === 'true' ) {
                    this.menuIcon.attr('aria-expanded', 'false');
                    this.menuIcon.text(this.menuIcon.attr('data-closed-text'));
                } else {
                    this.menuIcon.attr('aria-expanded', 'true');
                    this.menuIcon.text(this.menuIcon.attr('data-open-text'));
                }
            });
        }
    
        initStickyDetection () {
            $(window).on('scroll', () => {
                let positionY = this.win.scrollTop();
    
                if (positionY > 20 && !this.menuWrapper.hasClass('is-sticky')) {
                    this.menuWrapper.addClass('is-sticky');
                    return;
                }
    
                if (positionY <= 20 && this.menuWrapper.hasClass('is-sticky')) {
                    this.menuWrapper.removeClass('is-sticky');
                }
            });
    
            $(window).trigger('scroll');
        }
    
        setStickyState () {
            if (this.menuIsSticky) {
                $('.site-header').addClass('is-sticky');
            } else {
                $('.site-header').removeClass('is-sticky');
            }
        }
    }
    
    /**
     * Cookie Banner
     * 
     * Copyright (c) 2024 Tomasz Dziuda
     * Licensed under the MIT license
     */
    
    /*
     Connections:
     -------------------------------------------------------------------------------
     * google - Google
     * maps - Google Maps
     * 
    */
    
    (function ($) {
        var config = {
            debugMode: true,
            userConsents: {
                google: false,
                maps: false
            },
            userUUID: 'not-set',
            groups: [
                'google',
                'maps'
            ],
            allowedGroups: []
        };
      
        var UI = {
            basicWindow: $('.cn-info'),
            extendedWindow: $('.cn-info-extended'),
            buttons: {
                basicShowExtended: $('.cn-info-button-show-extended'),
                basicAcceptAll: $('.cn-info-button-accept-all'),
                basicRejectAll: $('.cn-info-button-reject-all'),
                extendedAcceptAll: $('.cn-info-extended-button-accept-all'),
                extendedSaveConfig: $('.cn-info-extended-button-save-consent'),
                extendedNotNow: $('.cn-info-extended-button-close-without-save')
            },
            checkboxes: {
                google: $('.cn-consent-checkbox[data-consent-type="google"]'),
                maps: $('.cn-consent-checkbox[data-consent-type="maps"]')
            }
        };
      
        if (UI.basicWindow.length) {
            initEvents();
            initPublicAPI();
            checkConfig(config);
        }
      
        function checkConfig () {
            var configFromCookie = Cookies.get(window.cnConfig.cookieName, { path: window.cnConfig.path });
      
            // When no config - show popup
            if (!configFromCookie) {
                if (config.debugMode) {
                    console.log('⛔️ Consent config not found - showing popup');
                }
      
                config.userUUID = generateUUID();
    
                // Not open on privacy policy page
                if (!$(document.body).hasClass('privacy-policy')) {
                    showPopup();
                }
    
                return;
            }
      
            // otherwise - load config without showing popup
            loadConfig(configFromCookie);
        }
      
        function loadConfig (configFromCookie) {
            config.userConsents.google = configFromCookie.indexOf('google') > -1;
            config.userConsents.maps = configFromCookie.indexOf('maps') > -1;
            let configParts = configFromCookie.split('||');
        
            if (configParts[1]) {
                config.userUUID = configParts[1].replace(/[^a-zA-Z0-9\-]/gmi, '');
            } else {
                config.userUUID = generateUUID();
            }
            
            for (var i = 0; i < config.groups.length; i++) {
                var groupName = config.groups[i];
      
                if (config.userConsents[groupName]) {
                    config.allowedGroups.push(groupName);
                }
            }
      
            if (config.debugMode) {
                console.log('⚙️ Founded config:', JSON.parse(JSON.stringify(config.userConsents)));
            }
        }
      
        function initEvents () {
            $(document).find('a[href="#cookie-settings"]').on('click', e => {
                e.preventDefault();
                showExtendedPopup();
            });
      
            UI.buttons.basicShowExtended.on('click', e => {
                e.preventDefault();
                closePopup();
                showExtendedPopup();
            });
      
            UI.buttons.basicAcceptAll.on('click', e => {
                e.preventDefault();
                giveConsentForAll();
                closePopup();
            });
      
            UI.buttons.basicRejectAll.on('click', e => {
                e.preventDefault();
                resetCookieConfig();
                closePopup();
            });
      
            UI.buttons.extendedAcceptAll.on('click', e => {
                e.preventDefault();
                giveConsentForAll();
                closeExtendedPopup();
            });
      
            UI.buttons.extendedSaveConfig.on('click', e => {
                e.preventDefault();
                saveConsent();
                closeExtendedPopup();
            });
      
            UI.buttons.extendedNotNow.on('click', e => {
                e.preventDefault();
                closeExtendedPopup();
                var configFromCookie = Cookies.get(window.cnConfig.cookieName, { path: window.cnConfig.path });
      
                if (!configFromCookie) {
                    showPopup();
                }
            });
        }
      
        function setCheckboxes () {
            for (var i = 0; i < config.groups.length; i++) {
                var group = config.groups[i];
      
                if (config.userConsents[group]) {
                    UI.checkboxes[group].prop('checked', true);
                } else {
                    UI.checkboxes[group].prop('checked', false);
                }
            }
        }
      
        function initPublicAPI () {
            window.cnCookieBanner = {
                giveConsentAndSave: function (type) {
                    giveConsentAndSave(type);
                },
                giveConsentAndSaveAndLoad: function (type) {
                    giveConsentAndSave(type, true);
                },
                showExtendedPopup: function () {
                    showExtendedPopup();
                },
                getConsentStatus: function (type) {
                    getConsentStatus(type);
                }
            };
        }
      
        function showPopup () {
            UI.basicWindow.removeClass('is-hidden');
        }
      
        function closePopup () {
            UI.basicWindow.addClass('is-hidden');
        }
      
        function showExtendedPopup () {
            UI.extendedWindow.removeClass('is-hidden');
            $(document.body).addClass('no-scroll');
            setCheckboxes();
        }
      
        function closeExtendedPopup () {
            UI.extendedWindow.addClass('is-hidden');
            $(document.body).removeClass('no-scroll');
        }
      
        function giveConsentForAll () {
            giveConsent('google');
            giveConsent('maps');
            saveConsentConfigInCookie(false);
        }
      
        function giveConsent (type, forceOnLoad = false) {
            if (config.debugMode) {
                console.log('✅ User gave consent:', type);
            }
      
            // If consent has been previously given - do nothing
            if (config.allowedGroups.indexOf(type) > -1) {
                return;
            }
      
            config.userConsents[type] = true;
      
            if (type === 'google') {
                allowGoogle();
                return;
            }
    
            if (type === 'maps') {
                allowGoogleMaps();
                return;
            }
        }
      
        function giveConsentAndSave (type, forceOnLoad = false) {
            giveConsent(type, forceOnLoad);
            saveConsentConfigInCookie(false);
        }
      
        function saveConsent () {
            var consentCompare = compareConsents();
            setConsentBasedOnCheckboxes();
      
            // if some consent has been removed
            if (consentCompare === 'some-rejected') {
                saveConsentConfigInCookie(true);
                window.location.reload();
                return;
            }
      
            // otherwise - if some consent has been added
            saveConsentConfigInCookie(false);
        }
      
        function setConsentBasedOnCheckboxes () {
            for (var i = 0; i < config.groups.length; i++) { 
                var group = config.groups[i];
      
                if (!!UI.checkboxes[group].prop('checked')) {
                    giveConsent(group);
                }
      
                config.userConsents[group] = !!UI.checkboxes[group].prop('checked');
            }
        }
      
        function saveConsentConfigInCookie (reloadNeeded = false) {
            var configToSave = [];
      
            for (var i = 0; i < config.groups.length; i++) {
                var group = config.groups[i];
      
                if (config.userConsents[group]) {
                    configToSave.push(group);
                }
            }
      
            if (configToSave.length) {
                Cookies.set(window.cnConfig.cookieName, configToSave.join(';') + '||' + config.userUUID, { expires: 180, path: window.cnConfig.path });
      
                if (config.debugMode) {
                    console.log('🍪 Consent config saved in the cookie');
                }
            } else {
                Cookies.set(window.cnConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.cnConfig.path });
            }
    
            let dataToSave = {
                consent_id: config.userUUID,
                consent_revision: window.cnConfig.cookieName,
                consent_content: configToSave.join(';'),
                consent_timestamp: +new Date(),
                url: window.location.pathname,
                delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
            };
          
            if ('sendBeacon' in navigator) {
                const formData = $.param(dataToSave);
                const blob = new Blob(
                    [formData], 
                    {
                        type : 'application/x-www-form-urlencoded'
                    }
                );
                navigator.sendBeacon('https://' + window.location.hostname + '/wp-json/cmp/v1/save', blob);
                
                if (reloadNeeded) {
                    window.location.reload();
                }
              } else {
                $.ajax({
                    url: 'https://' + window.location.hostname + '/wp-json/cmp/v1/save',
                    type: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    data: $.param(dataToSave),
                    success: function () {
                        if (reloadNeeded) {
                            window.location.reload();
                        }
                    },
                    fail: function () {
                        if (reloadNeeded) {
                            window.location.reload();
                        }
                    }
                });
            }
        }
      
        function resetCookieConfig () {
            Cookies.set(window.cnConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.cnConfig.path });
      
            if (config.debugMode) {
                console.log('🗑 User rejected all cookies - save empty config cookie');
            }
    
            let dataToSave = {
                consent_id: config.userUUID,
                consent_revision: window.cnConfig.cookieName,
                consent_content: '',
                consent_timestamp: +new Date(),
                url: window.location.pathname,
                delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
            };
    
            let reloadNeeded = window.cnUnlocked.length > 0;
            
            if ('sendBeacon' in navigator) {
                const formData = $.param(dataToSave);
                const blob = new Blob(
                    [formData], 
                    {
                        type : 'application/x-www-form-urlencoded'
                    }
                );
                navigator.sendBeacon('https://' + window.location.hostname + '/wp-json/cmp/v1/save', blob);
    
                if (reloadNeeded) {
                    window.location.reload();
                }
            } else {
                $.ajax({
                    url: 'https://' + window.location.hostname + '/wp-json/cmp/v1/save',
                    type: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    data: $.param(dataToSave),
                    success: function () {
                        if (reloadNeeded) {
                            window.location.reload();
                        }
                    },
                    fail: function () {
                        if (reloadNeeded) {
                            window.location.reload();
                        }
                    }
                });
            }
        }
      
        function compareConsents () {
            var someRejected = false;
      
            for (var i = 0; i < config.groups.length; i++) {
                var group = config.groups[i];
      
                if (config.userConsents[group] && !UI.checkboxes[group].prop('checked')) {
                    someRejected = true;
                }
            }
      
            if (someRejected) {
                if (config.debugMode) {
                    console.log('🔄 Some consents has been rejected - website reload needed');
                }
      
                return 'some-rejected';
            }
      
            if (config.debugMode) {
                console.log('ℹ️ User not rejected any consents - website reload not needed');
            }
      
            return 'some-added-or-not-changed';
        }
      
        function getConsentStatus (type) {
            return !!config.userConsents[type];
        }
      
        function allowGoogle () {
            if (window.cnUnlocked.indexOf('google') > -1) {
                return;
            }
    
      
            window.cnUnlockConsentedScript('google', 'head', true);
        }
    
        function allowGoogleMaps () {
            if (window.cnUnlocked.indexOf('maps') > -1) {
                return;
            }
      
            window.cnUnlockGoogleMaps(true);
        }
    
        function generateUUID () {
            var crypto = window.crypto || window.msCrypto;
            if (crypto && crypto.randomUUID) {
                let uuid = crypto.randomUUID();
                return uuid;
            }
            if (window.Uint8Array && crypto && crypto.getRandomValues) {
                let bytes = new Uint8Array(16);
                crypto.getRandomValues(bytes);
                bytes[6] = (bytes[6] & 0x0f) | 0x40;
                bytes[8] = (bytes[8] & 0x3f) | 0x80;
                let uuid = Array.prototype.map.call(bytes, (b, i) => {
                    return ((b < 16) ? '0' : '') + b.toString(16) + (((i % 2) && (i < 10) && (i > 2)) ? "-" : "");
                }).join('');
                return uuid;
            }
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (dt + Math.random()*16)%16 | 0;
                dt = Math.floor(dt/16);
                return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        }
    })(jQuery);

    new Clinic_Menu();
    new Clinic_FAQ();
})(jQuery);